// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChargeChangeInitiator {
  Unknown = "UNKNOWN",
  Customer = "CUSTOMER",
  CallCenterEmployee = "CALL_CENTER_EMPLOYEE",
  Distributor = "DISTRIBUTOR",
  System = "SYSTEM",
}
export default ChargeChangeInitiator;
